var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.865,92.391l-6.923-6.923a.461.461,0,0,0-.653.653l6.135,6.135H5.462a.462.462,0,1,0,0,.923H19.424l-6.135,6.135a.461.461,0,1,0,.653.653l6.923-6.923A.461.461,0,0,0,20.865,92.391Z","transform":"translate(-5 -85.333)"}));
}

ArrowRightInline.defaultProps = {"width":"16","height":"14.769","viewBox":"0 0 16 14.769"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
